import * as React from "react";
import { createRoot } from "react-dom/client";
import App from "./components/App";
import { FluentProvider, webLightTheme } from "@fluentui/react-components";
// Import Tailwind CSS styles from shared package
import "@carousel-office/shared/styles/main.css";
import { bridgePlannerServiceToWindow } from "./services/helpers";
import { getPromptService } from "../main/prompts";

/* global document, Office, module, require, HTMLElement */

const title = "AlphaSense for PowerPoint";

console.log('='.repeat(60));
console.log('[App] AlphaSense for PowerPoint - Initializing...');
console.log('[App] Version: 1.0.0');
console.log('[App] Environment:', process.env.NODE_ENV || 'development');
console.log('='.repeat(60));

const rootElement: HTMLElement | null = document.getElementById("container");
console.log('[App] Root container element:', rootElement ? 'Found' : 'Not found');

const root = rootElement ? createRoot(rootElement) : undefined;

if (!root) {
  console.error('[App] Failed to create React root - container element not found!');
}

/* Render application after Office initializes */
console.log('[App] Waiting for Office.js to initialize...');
Office.onReady((info) => {
  // ENTRY POINT FOR PPT ADDIN
  console.log('[App] Office.js initialized successfully!');
  console.log('[App] Office Host:', info.host);
  console.log('[App] Platform:', info.platform);

  try {
    const addinApi = (Office as any)?.addin;
    const startupBehavior = (Office as any)?.StartupBehavior?.load;
    if (typeof addinApi?.setStartupBehavior === "function" && startupBehavior !== undefined) {
      void Promise.resolve(addinApi.setStartupBehavior(startupBehavior)).catch((error: unknown) => {
        console.warn("[App] Could not set taskpane startup behavior to load:", error);
      });
    }
  } catch (error) {
    console.warn("[App] Startup behavior API unavailable:", error);
  }
  
  if (info.host === Office.HostType.PowerPoint) {
    console.log('[App] ✓ Running in PowerPoint - Correct host!');
  } else {
    console.warn('[App] ⚠ Running in unexpected host:', info.host);
  }

  // Initialize prompt service with background sync
  console.log('[App] Initializing PromptService...');
  const promptService = getPromptService();
  promptService.initialize()
    .then(() => {
      console.log('[App] ✓ PromptService initialized');
      // Start background sync (every 15 minutes)
      promptService.startBackgroundSync(15 * 60 * 1000);
      console.log('[App] ✓ Background prompt sync started (every 15 min)');
    })
    .catch((error) => {
      console.error('[App] ⚠️ PromptService initialization failed (will use code fallbacks):', error);
    });
  
  // Bridge planner service functions to window
  console.log('[App] Bridging planner service functions to window...');
  bridgePlannerServiceToWindow(window);
  console.log('[App] ✓ Planner service bridge complete');

  console.log('[App] Rendering React application...');
  root?.render(
    <FluentProvider theme={webLightTheme}>
      <App title={title} />
    </FluentProvider>
  );
  console.log('[App] React application rendered successfully!');
  console.log('='.repeat(60));
});

if ((module as any).hot) {
  (module as any).hot.accept("./components/App", () => {
    const NextApp = require("./components/App").default;
    root?.render(NextApp);
  });
}
